import type { TFunction } from 'i18next';
import { IBankTransferDetails, formatIban } from '../models/payment-options.model';

const escapeHtml = (value: string): string =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

/**
 * Coordinate del bonifico per la variabile `payment` della mail di send-quote.
 *
 * `t` va fissato sulla lingua della MAIL (i18n.getFixedT(mailLanguage)), non su quella
 * del TA: le etichette finiscono nel template _it/_en del cliente. I valori sono scritti
 * dal TA e vanno escapati, perche' il template li stampa come HTML.
 *
 * Stringa vuota se il bonifico non e' fra i metodi: il template non mostra nulla.
 */
export const buildBankTransferEmailHtml = (
    bank: Partial<IBankTransferDetails> | null,
    t: TFunction,
): string => {
    if (!bank?.bank_iban || !bank.bank_account_holder) return '';

    const rows: [string, string | null | undefined][] = [
        ['paymentOptions.bank.accountHolder', bank.bank_account_holder],
        ['paymentOptions.bank.bankName', bank.bank_name],
        ['paymentOptions.bank.iban', formatIban(bank.bank_iban)],
        ['paymentOptions.bank.bic', bank.bank_bic],
        ['paymentOptions.client.reference', bank.bank_reference],
    ];

    const lines = rows
        .filter(([, v]) => !!v?.trim())
        .map(([label, v]) => `${escapeHtml(t(label))}: <strong>${escapeHtml(v!.trim())}</strong><br>`);

    if (bank.bank_instructions?.trim()) {
        lines.push(`<br>${escapeHtml(bank.bank_instructions.trim()).replace(/\n/g, '<br>')}<br>`);
    }

    const note = bank.bank_receipt_note?.trim() || t('paymentOptions.bank.defaultReceiptNote');
    lines.push(`<br><em>${escapeHtml(note)}</em>`);

    return lines.join('\n');
};
